<template>
  <div>
    <el-form ref="form" :model="dataForm" label-width="130px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="交易编号" >
            <el-input
              :disabled="inPutShow"
              v-model="dataForm.DealNo"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="交易时间" >
            <el-input
              :disabled="inPutShow"
              v-model="dataForm.DealTime"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="渠道名称">
            <el-input
              :disabled="inPutShow"
              v-model="dataForm.ChannelName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="交易渠道流水号">
            <el-input
              clearable
              :disabled="inPutShow"
              v-model="dataForm.ChannelNo"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="充值金额">
            <el-input
              clearable
              :disabled="inPutShow"
              v-model="dataForm.RechargeAmount"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>

export default {
  props: {
    dataForm: {
      type: Object,
      default: function () {
        return {}
      }
    },
    inPutShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
</style>